import { jsxs as l, jsx as a, Fragment as M } from "react/jsx-runtime";
import { c as w } from "./index-65016bfa.mjs";
import R, { useRef as L, useState as $, useLayoutEffect as T } from "react";
import { styled as n, css as i } from "styled-components";
import { BREAKPOINTS as I } from "@fcamna/shared-component-foundations";
import { u as A } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import { b as W } from "./useSlots-a1aa6a84.mjs";
import { Badge as y } from "./badge.js";
import { CloseButton as z } from "./closeButton.js";
import { Icon as K } from "./icon.js";
import { u as E } from "./useAccessibilityProps-2f24cf29.mjs";
import { u as F } from "./useWindowSize-88e90e04.mjs";
import { Button as B } from "./button.js";
import { ModalBody as V, ModalWindow as j, ModalHeader as k, ModalFooter as q } from "./modalWindow.js";
import "./_commonjsHelpers-92157f1b.mjs";
import "./iconButton.js";
import "./setup-0f23222d.mjs";
import "react-dom";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "@fcamna/shared-icons";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./useClient-0bbce34e.mjs";
import "./Aria-f5e019e2.mjs";
import "./disclosure.js";
import "./focusTrap.js";
import "./hTag-27bb1617.mjs";
import "./index-5d51183d.mjs";
import "./tslib.es6-59e1c9d8.mjs";
const H = n.div`
  &.Chip {
    ${({
  theme: {
    components: { chip: o }
  }
}) => i(o.Chip)};
  }
`, P = n.div`
  &.Chip__leading-icon {
    ${({
  theme: {
    components: { chip: o }
  }
}) => i(o.LeadingIconWrapper)};
  }
`, Q = n(K)`
  &.Chip__toggle-icon {
    ${({
  theme: {
    components: { chip: o }
  }
}) => i(o.ToggleIcon)};
  }
`, U = n(y)`
  &.Chip__badge {
    ${({
  theme: {
    components: { chip: o }
  }
}) => i(o.ChipBadge)};
  }
`, J = ({
  size: o = "medium",
  variant: c = "toggle",
  isDisabled: t = !1,
  children: m,
  onClick: p,
  isRadio: N,
  leadingIcon: e,
  badgeProps: s = {},
  isActive: u = !1,
  onDelete: C,
  isOpen: f = !1,
  accessibilityOptions: h = {}
}) => {
  const x = A({ label: "Chip" }), _ = c === "toggle", d = L(null), g = E(
    "button",
    { ariaLabel: m, ariaDisabled: t, ...h.chip },
    d
  ), G = (r) => {
    t || p == null || p(r, {
      type: c,
      label: m,
      values: [],
      isActive: !u
    });
  };
  return /* @__PURE__ */ l(
    H,
    {
      onClick: G,
      onKeyDown: (r) => {
        (r.code === "Enter" || r.code === "Space") && G(r);
      },
      tabIndex: p && !t ? 0 : void 0,
      "data-type": "chip",
      className: w([
        "Chip",
        `Chip--${o}`,
        `Chip--${c}`,
        {
          "Chip--disabled": t,
          "Chip--active": u,
          "Chip--clickable": !!p,
          "Chip--removable": !!C
        }
      ]),
      ref: d,
      ...g,
      ...x,
      children: [
        e && /* @__PURE__ */ a(P, { className: "Chip__leading-icon", children: e }),
        /* @__PURE__ */ a("span", { children: m }),
        (s == null ? void 0 : s.value) && !N && /* @__PURE__ */ a(
          U,
          {
            className: w(["Chip__badge", { "Chip__badge--disabled": t }]),
            ...s
          }
        ),
        C && /* @__PURE__ */ a(
          z,
          {
            className: w(["Chip__close-btn", { "Chip__close-btn--disabled": t }]),
            disabled: t,
            onClick: (r) => {
              t || (r.stopPropagation(), C());
            },
            onKeyDown: (r) => {
              r.stopPropagation();
            },
            tabIndex: t ? void 0 : 0,
            size: "xxsmall",
            accessibilityOptions: { ariaLabel: `remove ${m.toLowerCase()}`, ...h.removeButton }
          }
        ),
        !_ && /* @__PURE__ */ a(
          Q,
          {
            className: "Chip__toggle-icon",
            name: f ? "caretUp" : "caretDown",
            height: "20px",
            width: "20px"
          }
        )
      ]
    }
  );
}, b = n.div`
  &.ChipGroup {
    ${({
  theme: {
    components: { chip: o }
  }
}) => i(o.ChipGroup)};
  }
`, S = n.label`
  &.ChipGroup__label {
    ${({
  theme: {
    components: { chip: o }
  }
}) => i(o.ChipGroupLabel)};
  }
`, X = n.div`
  &.ChipGroup__actions {
    ${({
  theme: {
    components: { chip: o }
  }
}) => i(o.ActionButtonWrapper)};
  }
`, Y = n(V)`
  &.ChipGroup__ModalBody {
    ${({
  theme: {
    components: { chip: o }
  }
}) => i(o.ModalBody)};
  }
`, bo = ({
  children: o,
  onClear: c,
  label: t,
  modalProps: m = { title: "Filter Results", buttonText: "Close" },
  clearAllLabel: p = "Clear all",
  showAllLabel: N = "Show all",
  accessibilityOptions: e
}) => {
  var v, r;
  const s = A({ label: "Chip Group" }), u = W(o, { Chip: J }), C = L(null), [f, h] = $(!1), [x, _] = $(15), { width: d } = F(), g = R.Children.count(o), G = () => {
    d >= I.laptopMin ? _(15) : d >= I.tabletMin ? _(10) : _(5);
  };
  return T(() => {
    G();
  }, [d]), /* @__PURE__ */ l(M, { children: [
    /* @__PURE__ */ l(
      b,
      {
        className: "ChipGroup",
        ref: C,
        ...s,
        children: [
          t && /* @__PURE__ */ a(
            S,
            {
              className: "ChipGroup__label",
              "data-type": "chip-label",
              children: t
            }
          ),
          u.Chip,
          /* @__PURE__ */ l(X, { className: "ChipGroup__actions", children: [
            /* @__PURE__ */ a(
              B,
              {
                onClick: c,
                className: "ChipGroup__action ChipGroup__clear-all-btn",
                tabIndex: 0,
                variant: "text",
                size: "small",
                name: "clear-all",
                accessibilityOptions: e == null ? void 0 : e.clearAll,
                children: p
              }
            ),
            g > x && /* @__PURE__ */ l(M, { children: [
              /* @__PURE__ */ a("div", { className: "separator", children: "|" }),
              /* @__PURE__ */ l(
                B,
                {
                  className: "ChipGroup__action ChipGroup__show-all-btn",
                  onClick: () => h(!0),
                  tabIndex: 0,
                  variant: "text",
                  size: "small",
                  name: "show-all",
                  accessibilityOptions: e == null ? void 0 : e.showAll,
                  children: [
                    N,
                    " (",
                    g,
                    ")"
                  ]
                }
              )
            ] })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ l(
      j,
      {
        variant: "large",
        isOpen: f,
        onClose: () => h(!1),
        children: [
          /* @__PURE__ */ a(
            k,
            {
              onClose: () => h(!1),
              accessibilityOptions: (v = e == null ? void 0 : e.modal) == null ? void 0 : v.headerCloseButton,
              children: m.title
            }
          ),
          /* @__PURE__ */ l(Y, { className: "ChipGroup__ModalBody", children: [
            /* @__PURE__ */ l(b, { className: "ChipGroup ModalBody", children: [
              t && /* @__PURE__ */ a(S, { className: "ChipGroup__label", children: t }),
              f && u.Chip
            ] }),
            /* @__PURE__ */ a(
              B,
              {
                variant: "text",
                size: "small",
                onClick: c,
                name: "clear-all",
                className: "ChipGroup__action ChipGroup__clear-all-btn",
                children: p
              }
            )
          ] }),
          /* @__PURE__ */ a(q, { placement: "right", children: /* @__PURE__ */ a(
            B,
            {
              onClick: () => h(!1),
              accessibilityOptions: (r = e == null ? void 0 : e.modal) == null ? void 0 : r.footerActionButton,
              children: m.buttonText
            }
          ) })
        ]
      }
    )
  ] });
};
export {
  J as Chip,
  bo as ChipGroup
};
